var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcn5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e23038;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.56,15.26H6.92v32.9h6.69a6.58,6.58,0,1,0,13.16,0H43.34a6.58,6.58,0,0,0,13.16,0h6.58V26.77A11.53,11.53,0,0,0,51.56,15.26ZM10.21,18.55H51.56a8.21,8.21,0,0,1,6.58,3.29H10.21Zm36.42,6.58v6.58h-10V25.13Zm-13.28,0v6.58H23.48V25.13Zm-23.14,0h10v6.58h-10Zm10,26.32a3.29,3.29,0,1,1,3.29-3.29A3.29,3.29,0,0,1,20.19,51.45Zm29.73,0a3.29,3.29,0,1,1,3.29-3.29A3.29,3.29,0,0,1,49.92,51.45Zm9.87-6.58H55.61a6.57,6.57,0,0,0-11.39,0H25.89a6.57,6.57,0,0,0-11.39,0H10.21V35H47.88l11.91,6Zm0-7.6-9.87-4.93V25.13h9.7a8.07,8.07,0,0,1,.17,1.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 70,
    height: 70
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn5);
export default __webpack_public_path__ + "static/media/icn_5.1fa6a0ebc0c81bde48ecaa9341174547.svg";
export { ForwardRef as ReactComponent };